import axios from "./axios";
import "./Row.css";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
import React, { useEffect, useState } from "react";
const baseURL1 = "https://www.themoviedb.org/t/p/w600_and_h900_bestv2/";
const baseURL2 = "https://www.themoviedb.org/t/p/w533_and_h300_bestv2/";
const luca =
  "https://nerdreactor.com/wp-content/uploads/2021/06/Luca-Pixar-side-800x450.jpg";

function Row({ title, Url, isLargerRow }) {
  const [movie, setMovie] = useState([]);
  var [trailerUrl, setTrailerUrl] = useState("");
  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(Url);
      setMovie(request.data.results);
      return request;
    }
    fetchData();
  }, [Url]);

  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
      origin: "https://localhost:3000",
    },
    //https://youtu.be/KS2EztRMuRw
  };
  const handleClick = (movie) => {
    console.log(movie);
    if (trailerUrl) {
      setTrailerUrl("");
    } else if (movie.name === "Money Heist") {
      setTrailerUrl("htqXL94Rza4");
    } else if (movie.name === "Lucifer") {
      setTrailerUrl("ueMwVGBwqRo");
    } else if (movie.name === "Sex/Life") {
      setTrailerUrl("x580mowu5Gs");
    } else if (movie.name === "The Snitch Cartel: Origins") {
      setTrailerUrl("vYZSxXcwJmw");
    } else if (movie.name === "Elite") {
      setTrailerUrl("QNwhAdrdwp0");
    } else if (movie.name === "Cobra Kai") {
      setTrailerUrl("xCwwxNbtK6Y");
    } else if (movie.name === "Control Z") {
      setTrailerUrl("P9rEPJ65UIw");
    } else if (movie.name === "Open Your Eyes") {
      setTrailerUrl("7LvSyuM6XSU");
    } else if (movie.name === "Sex Education") {
      setTrailerUrl("Hd2ldTR-WpI");
    } else if (movie.name === "Record of Ragnarok") {
      setTrailerUrl("z_pzeLrog8c");
    } else if (movie.name === "Ragnarok") {
      setTrailerUrl("i2qDt5D8RSs");
    } else if (movie.name === "Stranger Things") {
      setTrailerUrl("e4XvO7DItmc");
    } else if (movie.name === "Sweet Tooth") {
      setTrailerUrl("9zG9RuJb3QU");
    } else if (movie.name === "The Umbrella Academy") {
      setTrailerUrl("0DAmWHxeoKw");
    } else if (movie.name === "The War Next-door") {
      setTrailerUrl("JP-DxxcFYR0");
    } else if (movie.name === "Who Killed Sara?") {
      setTrailerUrl("8ctRjR_DWAg");
    } else if (movie.name === "Sexy Beasts") {
      setTrailerUrl("IJO5m6EFL6A");
    } else if (movie.name === "Chilling Adventures of Sabrina") {
      setTrailerUrl("R2gbPxeNk2E");
    } else if (movie.name === "Katla") {
      setTrailerUrl("X9zZl5nov68");
    } else if (movie.name === "Lupin") {
      setTrailerUrl("ga0iTWXCGa0");
    } else if (movie.name === "The Suicide Squad") {
      setTrailerUrl("JuDLepNa7hw");
    } else if (movie.title === "F9") {
      setTrailerUrl("aSiDu3Ywi8E");
    } else if (movie.title === "Shang-Chi and the Legend of the Ten Rings") {
      setTrailerUrl("8YjFbMbfXaQ");
    } else if (movie.title === "Cinderella") {
      setTrailerUrl("T1NeHRuPpoM");
    } else if (movie.title === "Reminiscence") {
      setTrailerUrl("_BggT--yxf0");
    } else if (movie.title === "Vacation Friends") {
      setTrailerUrl("1cKWKyh6d1k");
    } else if (movie.title === "Jungle Cruise") {
      setTrailerUrl("f_HvoipFcA8");
    } else if (movie.name === "See") {
      setTrailerUrl("7Rg0y7NT1gU");
    } else if (movie.name === "The Walking Dead") {
      setTrailerUrl("sfAc2U20uyg");
    } else if (movie.title === "Free Guy") {
      setTrailerUrl("X2m-08cOAbc");
    } else if (movie.name === "The Tomorrow War") {
      setTrailerUrl("QPistcpGB8o");
    } else if (movie.title === "Narco Sub") {
      setTrailerUrl("xFye5F5DdMY");
    } else if (movie.title === "Infinite") {
      setTrailerUrl("_WWEOCQGxSw");
    } else if (movie.title === "Mortal Kombat") {
      setTrailerUrl("NYH2sLid0Zc");
    } else if (movie.title === "Wrath of Man") {
      setTrailerUrl("EFYEni2gsK0");
    } else if (movie.title === "The Boss Baby: Family Business") {
      setTrailerUrl("QPzy8Ckza08");
    } else if (movie.name === "Insensate") {
      setTrailerUrl("");
    } else {
      if (trailerUrl) {
        setTrailerUrl("");
      } else {
        movieTrailer(movie?.name || movie?.title || movie?.original_name || "")
          .then((url) => {
            const urlParams = new URLSearchParams(new URL(url).search);
            setTrailerUrl(urlParams.get("v"));
          })
          .catch((error) => console.log(error));
      }
    }
  };
  // movie?.name === "Money Heist" ? (trailerUrl = "htqXL94Rza4") && istrue == true : istrue==false ;
  // var newid
  //   if(movie?.name==="Money Heist"){
  //     newid="htqXL94Rza4";
  //     istrue=true
  //   }
  //   else{
  // istrue=false
  //   }

  //"/uIXF0sQGXOxQhbaEaKOi2VYlIL0.jpg" [3].poster_path https://www.themoviedb.org/t/p/w533_and_h300_bestv2/4N6zEMfZ57zNEQcM8gWeERFupMv.jpg
  //"https://www.themoviedb.org/t/p/w600_and_h900_bestv2/g8kEsytBqK8hqpxe0OSf5hjXAYV.jpg"
  return (
    <div className="row">
      <h1 className="row-title"> {title}</h1>
      <div className={"row-movies"}>
        {movie.map((movie) => (
          <img
            key={movie.id}
            onClick={() => handleClick(movie)}
            className={`row-movie ${isLargerRow && "row-largeposter"}`}
            src={`${
              isLargerRow
                ? baseURL1
                : movie.title === "Luca: Our Italian Inspiration"
                ? ""
                : baseURL2
            }${
              isLargerRow
                ? movie.poster_path
                : movie.title === "Luca: Our Italian Inspiration"
                ? luca
                : movie.backdrop_path
            }`}
            alt={movie.name}
          />
        ))}
      </div>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
    </div>
  );
}
//https://www.themoviedb.org/t/p/w600_and_h900_bestv2/28mcCmmVbCUMeI7MEQrCFbzUifh.jpg
export default Row;
